import clsx from "clsx";
import LetterGrid from "./LetterGrid";
import Selector from "./Selector";
import classes from "./GameGrid.module.scss";


const GameGrid = ({
  tiles,
  gridSize,
  gridShown,
  currentQuestionIndex,
  gridRef,
  tileRefs,
  activeSelector,
  userAnswers,
  keyboardChain,
  navigationMode,
  onTileDown,
  onTileUp,
  onPointerMove,
  onPointerLeave
}) => {
  return (
    <div className={classes.gameArea}>
      <div
        className={clsx(classes.bg, gridShown ? classes.open : classes.closed)}
      >
        <LetterGrid
          tiles={tiles}
          onTileUp={onTileUp}
          onTileDown={onTileDown}
          onPointerMove={onPointerMove}
          onPointerLeave={onPointerLeave}
          ref={gridRef}
          active={activeSelector}
          gridSize={gridSize}
          tileRefs={tileRefs}
          userAnswers={userAnswers}
          keyboardChain={keyboardChain}
          navigationMode={navigationMode}
          className={gridShown ? classes.open : classes.closed}
          key={currentQuestionIndex}
        >
          {userAnswers.map((selection, idx) => {
            const foundWordIndex = selection.state === 1 ?
              userAnswers.filter((s, i) => i <= idx && s.state === 1).length - 1 :
              undefined;

            return (
              <Selector
                selection={selection}
                key={idx}
                placed
                foundWordIndex={foundWordIndex}
                shouldAnimate={selection.shouldAnimate}
              />
            );
          })}
          {activeSelector && <Selector selection={activeSelector} />}
        </LetterGrid>
      </div>
    </div>
  );
};

export default GameGrid;
